<div class="home-container">
  <h2 class="dashboard-header">{{localize(langSection.HomePage, langText.Header)}}</h2>
  @if (!isLoading ) {
<div class="dashboard">
    <div class="section-dates">
      <div class="date-range-picker-container ps-0">
        <date-range-picker [showUnreadCommentMeatballs]="true" [from]="filters" [to]="filters"
          (onChange)="onUpdatedDateRange($event)"></date-range-picker>
      </div>
    </div>
    <div class="section-comment-messages">
      <div class="comments-label ps-0">
        @if (preComments > 0) {
<span>{{preComments}} {{localize(langSection.DatePicker,
          langText.PriorComments)}}</span>
}
      </div>
      <div class="comments-label">
        @if (postComments > 0) {
<span>{{postComments}} {{localize(langSection.DatePicker,
          langText.FutureComments)}}</span>
}
      </div>
    </div>
    <div class="section-toggle location-toggle">
      <div role="button" class="show-section-indicator" [class.active]="showLocations" (click)="toggleLocations()">
        {{localize(langSection.Term, langText.Locations)}}
      </div>
    </div>
    <div #locationSection class="section-locations" [class.d-flex]="showLocations" [style.height]="locationsHeight">
      <location-list (locationsSelected)="onUpdateLocations($event)"></location-list>
    </div>
    <div class="section-buttons">
      <div class="buttons-container">
        <div class="request-buttons show-request-buttons">
          <button class="border-0 text-white bg-green round-button export-requests-button" (click)="exportRequests()"
            [disabled]="disableExport">{{localize(langSection.HomePage,
            langText.ExportRequests)}}</button>
          @if (auth.hasRole(roleType.User)) {
<button
            class="border-0 text-white bg-green round-button add-request-button"
            (click)="addRequest()">{{localize(langSection.HomePage, langText.AddRequest)}}</button>
}
        </div>
      </div>
    </div>
    <div class="section-request-buttons" [class.show-mobile-requests]="showRequests">
      <div class="buttons-container">
        <div class="request-buttons">
          <button class="border-0 text-white bg-green round-button export-requests-button" (click)="exportRequests()"
            [disabled]="disableExport">{{localize(langSection.HomePage,
            langText.ExportRequests)}}</button>
          @if (auth.hasRole(roleType.User)) {
<button
            class="border-0 text-white bg-green round-button add-request-button"
            (click)="addRequest()">{{localize(langSection.HomePage, langText.AddRequest)}}</button>
}
        </div>
      </div>
    </div>
    <div class="section-toggle request-toggle">
      <div role="button" class="show-section-indicator" [class.active]="showRequests" (click)="toggleRequests()">
        {{localize(langSection.HomePage, langText.Requests)}}
      </div>
    </div>
    @if (showRequestControls) {
<div class="section-status" [class.show-mobile-requests]="showRequests">
      @if (showFsAlert) {
<notification [title]="localize(langSection.HomePage, langText.FSNoticeTitle)"
        [message]="localize(langSection.HomePage, langText.FSNoticeText)" [allowClose]="false"></notification>
}
      <div class="request-status-buttons">
        <label class="btn btn-ups status-filter pt-3" (click)="filterTiles('total')"
          [ngClass]="{'selected': filters.statusFilters.includes(0)}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.totalCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span style="font-size:28px;">{{requestMetrics?.totalCount ||
              '0'}}<span>/{{locationMetrics.totalCount}}</span></span>
}
            <div class="status-name">{{localize(langSection.FilterChip, langText.TotalRequests)}}</div>
          </strong>
        </label>
        <label class="btn btn-ups status-filter pt-3" (click)="filterTiles('attentionNeeded')"
          [ngClass]="{'selected': filters.statusFilters.includes(1), 'attention-needed': locationMetrics && locationMetrics.attentionNeededCount > 0}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.attentionNeededCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{requestMetrics?.attentionNeededCount ||
              '0'}}<span>/{{locationMetrics.attentionNeededCount}}</span></span>
}
          </strong>
          @if (locationMetrics && locationMetrics.attentionNeededCommentsCount > 0) {
<span
            class="comments-indicator icon"></span>
}
          <div class="status-name">
            <strong>{{localize(langSection.FilterChip, langText.Attention)}}<br />{{localize(langSection.FilterChip,
              langText.Needed)}}</strong>
          </div>
        </label>
        <label class="btn btn-ups status-filter pt-3" (click)="filterTiles('pending')"
          [ngClass]="{'selected': filters.statusFilters.includes(2)}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.pendingCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span style="font-size:28px;">{{requestMetrics?.pendingCount
              || '0'}}<span>/{{locationMetrics.pendingCount}}</span></span>
}
          </strong>
          @if (locationMetrics && locationMetrics.pendingCommentsCount > 0) {
<span
            class="comments-indicator icon"></span>
}
          <div class="status-name">
            <strong>{{localize(langSection.FilterChip, langText.Pending)}}</strong>
          </div>
        </label>
        <label class="btn btn-ups status-filter pt-3" (click)="filterTiles('approved')"
          [ngClass]="{'selected': filters.statusFilters.includes(3)}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.approvedCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span style="font-size:28px;">{{requestMetrics?.approvedCount
              || '0'}}<span>/{{locationMetrics.approvedCount}}</span></span>
}
          </strong>
          @if (locationMetrics && locationMetrics.approvedCommentsCount > 0) {
<span
            class="comments-indicator icon"></span>
}
          <div class="status-name">
            <strong>{{localize(langSection.FilterChip, langText.Approved)}}</strong>
          </div>
        </label>
        <label class="btn btn-ups status-filter pt-3" (click)="filterTiles('scheduled')"
          [ngClass]="{'selected': filters.statusFilters.includes(4)}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.scheduledCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span style="font-size:28px;">{{requestMetrics?.scheduledCount
              || '0'}}<span>/{{locationMetrics.scheduledCount}}</span></span>
}
          </strong>
          @if (locationMetrics && locationMetrics.scheduledCommentsCount > 0) {
<span
            class="comments-indicator icon"></span>
}
          <div class="status-name">
            <strong>{{localize(langSection.FilterChip, langText.Scheduled)}}</strong>
          </div>
        </label>
        <label class="btn btn-ups status-filter pt-3" (click)="filterTiles('inTransit')"
          [ngClass]="{'selected': filters.statusFilters.includes(5)}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.inTransitCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span style="font-size:28px;">{{requestMetrics?.inTransitCount
              || '0'}}<span>/{{locationMetrics.inTransitCount}}</span></span>
}
          </strong>
          @if (locationMetrics && locationMetrics.inTransitCommentsCount > 0) {
<span
            class="comments-indicator icon"></span>
}
          <div class="status-name">
            <strong>{{localize(langSection.FilterChip, langText.InTransit)}}</strong>
          </div>
        </label>
        <label class="btn btn-ups status-filter pt-3" (click)="filterTiles('onProperty')"
          [ngClass]="{'selected': filters.statusFilters.includes(6)}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.onPropertyCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{requestMetrics?.onPropertyCount
              ||
              '0'}}<span>/{{locationMetrics.onPropertyCount}}</span></span>
}
          </strong>
          @if (locationMetrics && locationMetrics.onPropertyCommentsCount > 0) {
<span
            class="comments-indicator icon"></span>
}
          <div class="status-name">
            <strong>{{localize(langSection.FilterChip, langText.OnProperty)}}</strong>
          </div>
        </label>
        <label class="btn btn-ups status-filter pt-3" (click)="filterTiles('completed')"
          [ngClass]="{'selected': filters.statusFilters.includes(7)}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.completedCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span style="font-size:28px;">{{requestMetrics?.completedCount
              || '0'}}<span>/{{locationMetrics.completedCount}}</span></span>
}
          </strong>
          @if (locationMetrics && locationMetrics.completedCommentsCount > 0) {
<span
            class="comments-indicator icon"></span>
}
          <div class="status-name">
            <strong>{{localize(langSection.FilterChip, langText.Completed)}}</strong>
          </div>
        </label>
        <label class="btn btn-ups status-filter pt-3 p-0" (click)="filterTiles('canceledOrRejected')"
          [ngClass]="{'selected': filters.statusFilters.includes(8)}">
          <strong>
            @if (!showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{locationMetrics.canceledOrRejectedCount}}</span>
}
            @if (showRequestMetrics && locationMetrics) {
<span
              style="font-size:28px;">{{requestMetrics?.canceledOrRejectedCount ||
              '0'}}<span>/{{locationMetrics.canceledOrRejectedCount}}</span></span>
}
          </strong>
          @if (locationMetrics && locationMetrics.canceledOrRejectedCommentsCount > 0) {
<span
            class="comments-indicator icon"></span>
}
          <div class="status-name">
            <strong class="no-white-space">{{localize(langSection.FilterChip, langText.Canceled)}}
              /<br />{{localize(langSection.FilterChip, langText.NotFulfilled)}}</strong>
          </div>
        </label>
      </div>
    </div>
}
    @if (showRequestControls) {
<div class="section-filter" [class.d-flex]="showRequests">
      <div class="inline-buttons">
        <div class="search">
          <div class="form-group">
            <label class="fw-bold form-label">{{localize(langSection.HomePage, langText.SearchRequests)}}</label>
            <div class="input-group-text">
              <input type="text" class="form-control" [(ngModel)]="requestQuery" (ngModelChange)="filterRequests()" />
              <button aria-label="Search" class="btn border-dark rounded-0 bg-green" type="button"
                (click)="clearSearch()"><span class="{{iconClass}}"></span></button>
            </div>
          </div>
          <button aria-label="Open Filters" class="filter-button btn" type="button" (click)="onFilterClick()"
            [ngClass]="showActiveFilter ? 'active' : ''"></button>
        </div>
        <div class="sort inline-sort">
          <div class="form-group">
            <label class="form-label" for="sortBy"><strong>{{localize(langSection.HomePage,
                langText.SortBy)}}</strong></label>
            <ups-select (change)="onSortChange($event.target.value)" id="sortBy" [list]="sortOptions"
              [value]="sortInitVal"></ups-select>
          </div>
          <button aria-label="Ascending or Descending" class="up-and-down-sort btn" type="button"
            (click)="onSortClick()"></button>
        </div>
      </div>
      <filter-form class="filter-form-lg" (filterEvent)="receiveFilter($event)"
        [ngClass]="showFilters ? 'showFilters' : ''" [value]="filters"></filter-form>
      <div class="sort">
        <div class="form-group">
          <label class="form-label" for="sortBy"><strong>{{localize(langSection.HomePage,
              langText.SortBy)}}</strong></label>
          <ups-select (change)="onSortChange($event.target.value)" id="sortBy" [list]="sortOptions"
            [value]="sortInitVal"></ups-select>
        </div>
        <button aria-label="Ascending or Descending" class="up-and-down-sort btn" type="button"
          (click)="onSortClick()"></button>
      </div>
    </div>
}
    <div class="section-requests" [class.d-flex]="showRequests">
      <trailer-request [requests]="requests"></trailer-request>
    </div>
    <div #gridBottom class="view-bottom">
    </div>
  </div>
} @else {

  <div style="width:100vw">{{localize(langSection.Term, langText.Loading)}}</div>

}
</div>
